import { RegistryItem } from "@schemas/agreements/schema";
import { AgreementTypeEnum, CalculationMethodType } from "__generated__/graphql";

export const LumpsumSchema: RegistryItem = {
	[AgreementTypeEnum.Lumpsum]: {
		defaultValues: {
			calculationMethod: {
				type: CalculationMethodType.Lumpsum,
			},
		},
		agreementFields: {
			"agreement.manualActionRequired": { rules: { hidden: true } },
		},
		calculationMethodFields: {
			"calculationMethod.type": { rules: { hidden: true } },
		},
	},
};
